import { createSlice } from '@reduxjs/toolkit';

import { EMPTY_PLAYERS_LIST } from '../constants';


const initialState = {
  competitors: [],
  players: [],
  selectedPlayers: EMPTY_PLAYERS_LIST,
};

const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    aGetCompetitorsSuccess: (state, action) => {
      state.competitors = action.payload.competitors;
    },
    aSaveUpdatedSquadListSuccess: (state, action) => {
      state.competitors = action.payload.competitors;
    },
    aSaveNewPlayerSuccess: (state, action) => {
      state.players = action.payload.players;
    },
    aDisablePlayerSuccess: (state, action) => {
      state.players = action.payload.players;
    },
    aGetPlayersSuccess: (state, action) => {
      state.players = action.payload.players;
      state.selectedPlayers = action.payload.selectedPlayers;
    },
    aUpdatePlayersOnSquadSuccess: (state, action) => {
      state.players = action.payload.players;
      state.selectedPlayers = action.payload.selectedPlayers;
    },
    aClearTeamDetails: (state) => {
      state.players = [];
      state.selectedPlayers = EMPTY_PLAYERS_LIST;
    },
    aGetPlayersTemplateSuccess: (state, action) => {
      state.playersTemplate = action.payload.players;
    },
    aGetLiveTemplateFileSuccess: (state, action) => {
      state.liveTemplateFiles = action.payload.templateFiles;
    },
    aGetTennisLiveTemplateFileSuccess: (state, action) => {
      state.tennisliveTemplateFiles = action.payload.templateFiles;
    },
    aGetLiveTemplateSuccess: (state, action) => {
      state.liveTemplates = action.payload.liveTemplates;
    },
    aGetTennisLiveTemplateSuccess: (state, action) => {
      state.tennisLiveTemplates = action.payload.liveTemplates;
    },
    aGetPlayersTemplateFileSuccess: (state, action) => {
      state.templateFiles = action.payload.templateFiles;
    },
    aDownloadPlayersTemplateFileSuccess: (state, action) => {
      state.downloadedTemplateFile = action.payload.downloadedTemplateFile;
    },
    aDownloadLiveTemplateFileSuccess: (state, action) => {
      state.downloadedLiveTemplateFile = action.payload.downloadedTemplateFile;
    },
    aDownloadTennisLiveTemplateFileSuccess: (state, action) => {
      state.downloadedTennisLiveTemplateFile = action.payload.downloadedTemplateFile;
    },
    aSavePlayersTemplatePreviewSuccess: (state, action) => {
      state.playersTemplatePreview = action.payload.playersTemplatePreview;
    },
  },
});

export const {
  aGetCompetitorsSuccess,
  aSaveUpdatedSquadListSuccess,
  aSaveNewPlayerSuccess,
  aDisablePlayerSuccess,
  aGetPlayersSuccess,
  aUpdatePlayersOnSquadSuccess,
  aClearTeamDetails,
  aGetPlayersTemplateSuccess,
  aGetLiveTemplateFileSuccess,
  aGetTennisLiveTemplateFileSuccess,
  aGetLiveTemplateSuccess,
  aGetTennisLiveTemplateSuccess,
  aGetPlayersTemplateFileSuccess,
  aDownloadPlayersTemplateFileSuccess,
  aDownloadLiveTemplateFileSuccess,
  aDownloadTennisLiveTemplateFileSuccess,
  aSavePlayersTemplatePreviewSuccess,
} = teamsSlice.actions;

export default teamsSlice.reducer;

